<template>
	<div class="section" :class="[(stackedLayout ? 'stacked' : 'inline')]" v-if="(quoteOnly) ? stackedLayout : true">
		<slot v-bind="{ stackedLayout }">
			<div class="primary" :style="primary__inlineBackgroundImage" v-if="primary && !quoteOnly">
				<div :class="['primary__body', (primary.gravity || 'top left')]">
					<div class="primary__upper" :style="primary__stackedBackgroundImage">
						<div class="primary__headline">
							<container :collapse="!stackedLayout">
								<h2 v-html="primary.headline"></h2>
							</container>
						</div>
					</div>
					<div class="primary__lower">
						<container :collapse="!stackedLayout">
							<div v-html="primary.html"></div>
						</container>
					</div>
				</div>
			</div>
			<div class="aside" v-if="aside && (!stackedLayout || quoteOnly)">
				<div class="aside__image" :style="aside__backgroundImage"></div>
				<div class="aside__quote" v-if="aside.quote">
					<container :collapse="!stackedLayout">
						<blockquote class="quote">
							<div class="quote__text">
								<p>&ldquo;{{ aside.quote.quote }}&rdquo;</p>
							</div>
							<div class="quote__author">
								<Author v-bind="aside.quote.author" />
							</div>
						</blockquote>
					</container>
				</div>
			</div>
		</slot>
	</div>
</template>

<script>

	import Author from '@/components/Author'
	import _ from 'lodash'

	export default {
		components: { Author },
		props: {
			primary: Object,
			aside: Object,
			quoteOnly: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			stackedLayout () {
				return !this.$mq.desktop
			},
			primary__inlineBackgroundImage () {
				const url = _.get(this.primary, 'background.inline')
				if(!this.stackedLayout && url) {
					return { 'background-image': `url(${url})` }
				}
				return null
			},
			primary__stackedBackgroundImage () {
				const url = _.get(this.primary, 'background.stacked')
				if(this.stackedLayout && url) {
					return { 'background-image': `url(${url})` }
				}
				return null
			},
			aside__backgroundImage () {
				const variant = (this.stackedLayout) ? 'stacked' : 'inline'
				return { 'background-image': `url(${this.aside.background[variant]})` }
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";

	@mixin backgroundImageStyles {
		background-size:cover; background-position:center center;
	}

	@mixin textShadow {
		text-shadow: 1px 1px 0 rgba(0,0,0,0.80);
	}

	$inlinePrimaryBodyMargin: 4vw;

	/deep/ {
		h2 {
			line-height:1; text-transform:uppercase; font-weight:400;
		}
	}
	.section.stacked {
		/deep/ {
			h2 {
				font-size:5rem; position:relative;
			}
			.container {
				margin-top:5vw; margin-bottom:5vw;
			}
		}

	}
	.section.inline {
		/deep/ {
			h2 {
				@include responsive-font(60);
			}
		}
	}



	.quote {
		&__text {
			font-family: "oswald"; line-height:1.25; font-weight:400; position:relative; text-transform:uppercase; color:#FCB813
		}
		&__author {
			margin-top:1.25em;
		}
	}

	.section.stacked {
		.primary {
			&__upper {
				@include backgroundImageStyles;
				height:60vh; color:#fff; position:relative;
			}
			&__headline {
				position:absolute; bottom:0; left:0; right:0;
				&:before {
					position:absolute; top:0; left:0; right:0; bottom:0; opacity: 0.3; background-image: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, #000000 100%); content:'';
				}
			}
		}
		.aside {
			&__image {
				@include backgroundImageStyles;
				height:60vh;
			}
			&__quote {
				.quote {
					&__text {
						@include responsive-font(30);
					}
				}
			}
		}
	}

	.section.stacked + .section.stacked {
		margin-top:10vw;
	}

	.section.inline {
		display:flex; flex-direction:row-reverse; min-height:100vh;
		.primary {
			@include backgroundImageStyles;
			flex:1; color:#fff; position:relative;
			&__lower {
				margin-top:1em;
			}
			&__body {
				@include textShadow;
				max-width: 52rem; position:absolute; font-weight:600;
				&.left {
					left:$inlinePrimaryBodyMargin;
				}
				&.right {
					right:$inlinePrimaryBodyMargin;
				}
				&.top {
					top:$inlinePrimaryBodyMargin;
				}
				&.bottom {
					bottom:$inlinePrimaryBodyMargin;
				}
			}

		}
		.aside {
			flex-basis:30%; display:flex; flex-direction:column;
			&__image {
				@include backgroundImageStyles;
				flex:1;
			}
			&__quote {
				padding:3vw;
				.quote {
					&__text {
						@include responsive-font(20);
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/CompanyTour/components/TourSection.vue